import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

"use strict";
function DataApi() {
    $.extend(this, {
        update: function update_entity(entity, data) {
            if (typeof entity === "string") {
                var toks = entity.split("#");
                var entityName = toks[0];
                var entityId = toks[1];
                entity = uly.api.start()
                    .follow("uly:data")
                    .put("find", { "rel": entityName, "id": entityId }, data);

            } else {
                entity = HalResource(entity).put(null, data);
            }
            return entity.then(function(result) {
                uly.utils.show_results(result);
                if (result.success) {
                    uly.publish("entity.modified", {"entity":entity});
                }
            }, function(error) {
                uly.utils.show_results(error);
            });
        },
        delete: function delete_entity(entity, data) {
        },
        fetch: function fetch_entity(entity, data) {
        },
        create: function create_entity(entityType, origin, path, data) {
        }
    });
}

uly.data = new DataApi();
